import './index.less';

import Introduction from './Introduction.vue';

Introduction.install = function install(Vue) {
  Vue.component(Introduction.name, Introduction);
};

export default Introduction;
